
<template>
  <div class="content" @scroll="scrollEven">
    <div class="banner">
      <img
        src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/homeBanner2.png"
      />
      <div class="banner-text">
        <h3 class="banner-h" id="bannerH">{{ $t("home.title") }}</h3>
        <label>{{ $t("home.titleSecondaryTitle") }}</label>
      </div>
      <router-link to="/aboutUs">
        <!-- <div
          id="bannerButton"
          class="banner-button"
          @mouseover="mouseover"
          @mouseleave="mouseleave"
        >
          {{ $t("learnMore")
          }}<img
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go-white.png"
          />
        </div> -->
        <button
          id="bannerButton"
          class="banner-button"
          @mouseover="mouseover"
          @mouseleave="mouseleave"
        >
          {{ $t("learnMore")
          }}<img
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go-white.png"
          />
        </button>
      </router-link>
    </div>

    <div class="content-1">
      <div class="content-1-left">
        <img
          src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/home-p1.png"
          class="fromTop"
        />
      </div>
      <div class="content-1-right">
        <h3 class="move0">{{ $t("home.content1Title") }}</h3>
        <div class="seced move01">
          <div></div>
          <a>{{ $t("home.content1SecondaryTitle") }}</a>
        </div>
        <p class="move1">{{ $t("home.content1P1") }}</p>
        <p class="move2">{{ $t("home.content1P2") }}</p>
        <p class="move3">{{ $t("home.content1P3") }}</p>
        <p class="move31">{{ $t("home.content1P4") }}</p>
        <router-link to="/aboutUs">
          <!-- <div
            class="content1-button move4"
            @mouseover="mouseoverB"
            @mouseleave="mouseleaveB"
          >
            {{ $t("aboutUs")
            }}<img
              src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go.png"
            />
          </div> -->
          <button
            class="content1-button move4"
            @mouseover="mouseoverB"
            @mouseleave="mouseleaveB"
          >
            {{ $t("aboutUs")
            }}<img
              src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go.png"
            />
          </button>
        </router-link>
      </div>
    </div>
    <!-- <div class="content-2">
      <h1 class="move5">We are growing year-on-year at 30%.</h1>
      <div class="why move6">
        <div></div>
        <a>Here’s why.</a>
      </div>
      <img
        src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/down.png"
        class="move7"
      />
      <div class="img-list">
        <div class="card">
          <div class="card-color"></div>
          <img
            class="card-img"
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/passionate.png"
          />
          <div class="card-text">
            <h1>Passionate</h1>
            <label> We are committed to the industry we belong to. </label>
          </div>
        </div>
        <div class="card">
          <div class="card-color"></div>
          <img
            class="card-img"
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/passionate.png"
          />
          <div class="card-text">
            <h1>Genuine</h1>
            <label> In the end, the people we service, matter the most. </label>
          </div>
        </div>
        <div class="card">
          <div class="card-color"></div>
          <img
            class="card-img"
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/passionate.png"
          />
          <div class="card-text">
            <h1>Valued</h1>
            <label> Quality delivered within your budget and timeframe. </label>
          </div>
        </div>
        <div class="card">
          <div class="card-color"></div>
          <img
            class="card-img"
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/transparent.png"
          />
          <div class="card-text">
            <h1>Transparent</h1>
            <label> We are reliable because we do what we promise. </label>
          </div>
        </div>
      </div>
    </div> -->
    <div class="content-3">
      <div class="content3-left">
        <div class="content3-p move8">
          <h3>{{ $t("home.content2Title") }}</h3>
          <div class="seced">
            <div></div>
            <label>{{ $t("home.content2SecondaryTitle") }}</label>
          </div>
        </div>
        <div class="content3-list">
          <div class="card top move9">
            <!-- <img class="card-img" :src="right" /> -->
            <div class="card-text">
              <label class="text-top">{{ $t("home.major") }}</label>
              <label class="text-bottom">{{ $t("home.content2P1") }}</label>
            </div>
          </div>
          <div class="card move10">
            <!-- <img class="card-img" :src="right" /> -->
            <div class="card-text">
              <label class="text-top">{{ $t("home.innovate") }}</label>
              <label class="text-bottom">{{ $t("home.content2P2") }}</label>
            </div>
          </div>
          <div class="card move11">
            <!-- <img class="card-img" :src="right" /> -->
            <div class="card-text">
              <label class="text-top">{{ $t("home.collaborate") }}</label>
              <label class="text-bottom">{{ $t("home.content2P3") }}</label>
            </div>
          </div>
          <!-- <div class="card move12">
            <div class="card-text">
              <label class="text-top">{{ $t("home.winwin") }}</label>
              <label class="text-bottom">{{ $t("home.content2P4") }}</label>
            </div>
          </div> -->
        </div>
      </div>
      <div class="content3-right">
        <img
          src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/home-P2.png"
          class="surname3"
        />
      </div>
    </div>
    <div class="content-4">
      <h3 class="move13">
        {{ $t("home.content3Title") }}
      </h3>
      <div class="second-title move14">
        <div></div>
        <label>{{ $t("home.content4SecondaryTitle") }}</label>
      </div>
      <router-link to="/aboutUs">
        <!-- <div
          class="content4-button move15"
          @mouseover="mouseoverB"
          @mouseleave="mouseleaveB"
        >
          {{ $t("learnMore")
          }}<img
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go.png"
          />
        </div> -->
        <button
          class="content4-button move15"
          @mouseover="mouseoverB"
          @mouseleave="mouseleaveB"
        >
          {{ $t("learnMore")
          }}<img
            src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go.png"
          />
        </button>
      </router-link>

      <div class="card-list">
        <!-- <div
          class="card"
          @mouseover="(e) => mouseoverCard(e, 0)"
          @mouseleave="(e) => mouseleaveCard(e, 0)"
        >
          <img :src="ship2" />
          <h1>{{ $t("home.newShip") }}</h1>
          <p>{{ $t("home.content3P1") }}</p>
        </div>
        <div
          class="card"
          @mouseover="(e) => mouseoverCard(e, 1)"
          @mouseleave="(e) => mouseleaveCard(e, 1)"
        >
          <img :src="material" />
          <h1>{{ $t("home.material") }}</h1>
          <p>{{ $t("home.content3P2") }}</p>
        </div>
        <div
          class="card"
          @mouseover="(e) => mouseoverCard(e, 2)"
          @mouseleave="(e) => mouseleaveCard(e, 2)"
        >
          <img :src="food" />
          <h1>{{ $t("home.food") }}</h1>
          <p>{{ $t("home.content3P3") }}</p>
        </div>
        <div
          class="card"
          @mouseover="(e) => mouseoverCard(e, 3)"
          @mouseleave="(e) => mouseleaveCard(e, 3)"
        >
          <img :src="consumables" />
          <h1>{{ $t("home.consumables") }}</h1>
          <p>{{ $t("home.content3P4") }}</p>
        </div> -->

        <div
          class="card"
          :class="item.img ? `cardImg${it}` : ''"
          @mouseover="(e) => mouseoverCard(e, it)"
          @mouseleave="(e) => mouseleaveCard(e, it)"
          v-for="(item, it) in cardList"
          :key="it"
        >
          <img :src="item.img" />
          <h1>{{ $t(item.htext) }}</h1>
          <p>{{ $t(item.ptext) }}</p>
        </div>
      </div>
    </div>
    <div class="content-5">
      <div class="content5-help">
        <h1>{{ $t("home.footerTitle") }}</h1>
        <router-link to="/contact">
          <!-- <div
            class="content5-button"
            @mouseover="mouseover"
            @mouseleave="mouseleave"
          >
            {{ $t("tellUs")
            }}<img
              src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go-white.png"
            />
          </div> -->
          <button
            class="content5-button"
            @mouseover="mouseover"
            @mouseleave="mouseleave"
          >
            {{ $t("tellUs")
            }}<img
              src="http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go-white.png"
            />
          </button>
        </router-link>
      </div>
    </div>
    <footer class="app-footer">
      © 2022 Emsol Maine Service Pte Ltd. All Right Reserved.
    </footer>
  </div>
</template>

<script>
import homeP2 from "../assets/img/home-P2.png";
import right from "../assets/img/right.png";
import ship2 from "../assets/img/ship-2.png";
import food from "../assets/img/food.png";
import consumables from "../assets/img/consumables.png";
import material from "../assets/img/material.png";
import materialWhite from "../assets/img/materialWhite.png";
import ship2White from "../assets/img/ship-2-white.png";
import foodWhite from "../assets/img/foodWhite.png";
import consumablesWhite from "../assets/img/consumablesWhite.png";
// import SvgIcon from "../components/SvgIcon/index.vue";
export default {
  name: "app-home",
  data() {
    return {
      homeP2,
      right,
      ship2,
      food,
      consumables,
      material,
      materialWhite,
      ship2White,
      foodWhite,
      consumablesWhite,
      shipList: [ship2, material, food, consumables],
      shipWhiteList: [ship2White, materialWhite, foodWhite, consumablesWhite],
      cardList: [
        {
          img: ship2,
          htext: "home.newShip",
          ptext: "home.content3P1",
        },
        {
          img: material,
          htext: "home.material",
          ptext: "home.content3P2",
        },
        {
          img: food,
          htext: "home.food",
          ptext: "home.content3P3",
        },
        {
          img: consumables,
          htext: "home.consumables",
          ptext: "home.content3P4",
        },
      ],
      index: 0,
      tem: {},
    };
  },
  components: {
    // SvgIcon,
  },
  mounted() {
    // mouseoverCard();
  },
  methods: {
    mouseleaveCardLeave() {
      console.log(
        this.index,
        document.querySelector(`.cardImg${this.index}`),
        "index"
      );
      // this.tem.target.firstElementChild.src = this.shipWhiteList[this.index];
      let ql = document.querySelector(`.cardImg${this.index}`);
      if (ql) {
        // console.log((ql.src = this.shipWhiteList[this.index]), "ql");
        ql.firstElementChild.src = this.shipWhiteList[this.index];
      }
    },
    mouseover(e) {
      e.target.firstElementChild.src =
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go-black.png";
    },
    mouseleave(e) {
      e.target.firstElementChild.src =
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go-white.png";
    },
    mouseoverB(e) {
      e.target.firstElementChild.src =
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go-white.png";
    },
    mouseleaveB(e) {
      e.target.firstElementChild.src =
        "http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/go.png";
    },
    mouseoverCard(e, index) {
      this.tem = e;
      if (
        e.target &&
        e.target.firstElementChild &&
        e.target.firstElementChild.src
      ) {
        e.target.firstElementChild.src = this.shipWhiteList[index];
      }

      console.log(e.target, "eeee");
      this.index = index;
    },
    mouseleaveCard(e, index) {
      e.target.firstElementChild.src = this.shipList[index];
    },
    scrollEven(e) {
      let { scrollTop } = e.target;
      let realHeight =
        document.getElementsByClassName("content")[0].clientHeight +
        scrollTop +
        20;
      let move0 = document.getElementsByClassName("move0")[0];
      let move01 = document.getElementsByClassName("move01")[0];
      let move1 = document.getElementsByClassName("move1")[0];
      let move2 = document.getElementsByClassName("move2")[0];
      let move3 = document.getElementsByClassName("move3")[0];
      let move31 = document.getElementsByClassName("move31")[0];
      let move4 = document.getElementsByClassName("move4")[0];
      // let move5 = document.getElementsByClassName("move5")[0];
      // let move6 = document.getElementsByClassName("move6")[0];
      // let move7 = document.getElementsByClassName("move7")[0];
      let move8 = document.getElementsByClassName("move8")[0];
      let move9 = document.getElementsByClassName("move9")[0];
      let move10 = document.getElementsByClassName("move10")[0];
      let move11 = document.getElementsByClassName("move11")[0];
      // let move12 = document.getElementsByClassName("move12")[0];
      let move13 = document.getElementsByClassName("move13")[0];
      let move14 = document.getElementsByClassName("move14")[0];
      let move15 = document.getElementsByClassName("move15")[0];
      if (move0.offsetTop < realHeight) {
        move0.classList.add("fadeIn");
      }
      if (realHeight > move01.offsetTop) {
        move01.classList.add("fadeIn");
      }
      if (realHeight > move1.offsetTop) {
        move1.classList.add("fadeIn");
      }
      if (realHeight > move2.offsetTop) {
        move2.classList.add("fadeIn");
      }
      if (realHeight > move3.offsetTop) {
        move3.classList.add("fadeIn");
      }
      if (realHeight > move31.offsetTop) {
        move31.classList.add("fadeIn");
      }
      if (realHeight > move4.offsetTop) {
        move4.classList.add("fadeIn");
      }
      // else if (realHeight > move5.offsetTop && realHeight < move6.offsetTop) {
      //   move5.classList.add("fadeIn");
      // } else if (realHeight > move6.offsetTop && realHeight < move7.offsetTop) {
      //   move6.classList.add("fadeIn");
      // }
      // else if (realHeight > move7.offsetTop && realHeight < move8.offsetTop) {
      //   move7.classList.add("fadeIn");
      // }
      if (realHeight > move8.offsetTop) {
        move8.classList.add("fadeIn");
        document
          .getElementsByClassName("surname3")[0]
          .classList.add("fromLeft");
      }
      if (realHeight > move9.offsetTop) {
        move9.classList.add("fadeIn");
      }
      if (realHeight > move10.offsetTop) {
        move10.classList.add("fadeIn");
      }
      if (realHeight > move11.offsetTop) {
        move11.classList.add("fadeIn");
      }
      // if (realHeight > move12.offsetTop) {
      //   move12.classList.add("fadeIn");
      // }
      if (realHeight > move13.offsetTop) {
        move13.classList.add("fadeIn");
      }
      if (realHeight > move14.offsetTop) {
        move14.classList.add("fadeIn");
      }
      if (realHeight > move15.offsetTop) {
        move15.classList.add("fadeIn");
      }
    },
  },
};
</script>

<style lang="less">
.content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 80px);
  margin-top: 80px;
  overflow-y: scroll;
  a {
    text-decoration: none;
  }
  .banner {
    width: 100%;
    height: 686px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .banner-text {
      position: absolute;
      top: 213px;
      left: 240px;
      text-align: left;
      .banner-h {
        margin: 24px 0;
        font-size: 54px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #ffffff;
        line-height: 41px;
      }
      #bannerH {
        -webkit-animation: bannerH1 0.6s 0.2s ease both;
        -moz-animation: bannerH1 0.6s 0.2s ease both;
      }
      @-webkit-keyframes bannerH1 {
        0% {
          opacity: 0;
          -webkit-transform: translateX(200px);
        }
        100% {
          opacity: 1;
          -webkit-transform: translateX(0);
        }
      }
      @-moz-keyframes bannerH1 {
        0% {
          opacity: 0;
          -moz-transform: translateX(200px);
        }
        100% {
          opacity: 1;
          -moz-transform: translateX(0);
        }
      }
      label {
        font-size: 20px;
        font-family: Arial-Regular, Arial;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
      }
    }
    #bannerButton {
      -webkit-animation: bannerL 1s 0.2s ease both;
      -moz-animation: bannerL 1s 0.2s ease both;
    }
    @-webkit-keyframes bannerL {
      0% {
        opacity: 0;
        -webkit-transform: translateY(20px);
      }
      100% {
        opacity: 1;
        -webkit-transform: translateY(0);
      }
    }
    @-moz-keyframes bannerL {
      0% {
        opacity: 0;
        -moz-transform: translateY(20px);
      }
      100% {
        opacity: 1;
        -moz-transform: translateY(0);
      }
    }
    .banner-button {
      position: absolute;
      top: 431px;
      left: 240px;
      cursor: pointer;
      padding: 9px 19px 9px 22px;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      align-items: center;
      background-color: rgba(241, 243, 246, 0);
      border: 2px solid #fff;
      font-size: 16px;
      font-family: Arial-Regular, Arial;
      font-weight: Regular;
      color: #fff;
      background-clip: text;
      img {
        width: 16px;
        height: 16px;
        margin-left: 22px;
      }
    }
    .banner-button:hover {
      background: #fff;
      color: #000;
    }
  }
  .content-1 {
    margin: 120px auto;
    width: 1440px;
    display: flex;
    justify-content: space-between;
    .content-1-left {
      width: 674px;
      height: 693px;
      position: relative;
      .surname1 {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        transform: scaleX(0);
        border-radius: 10px;
        background-color: rgba(241, 243, 246, 0.7);
      }
      .surname2 {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        transform: scaleX(0);
        border-radius: 10px;
        background-color: rgba(241, 243, 246, 1);
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .content-1-right {
      width: 660px;
      text-align: left;
      .move0 {
        font-size: 40px;
        height: 40px;
        margin-top: 55px;
        margin-bottom: 25px;
        line-height: 40px;
        opacity: 0;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #2a2e2e;
      }
      .move01 {
        opacity: 0;
      }
      p {
        font-size: 16px;
        opacity: 0;
        font-family: Arial-Regular, Arial;
        font-weight: 400;
        color: #2a2e2e;
        margin: 35px 0;
        line-height: 30px;
      }
      .move1 {
        opacity: 0;
      }
      .move2 {
        opacity: 0;
      }
      .move3 {
        opacity: 0;
      }
      .move31 {
        opacity: 0;
      }
      .move4 {
        opacity: 0;
      }
      .content1-button {
        margin-top: 100px;
        cursor: pointer;
        padding: 9px 22px 9px 22px;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        align-items: center;
        border: 2px solid #2a358e;
        font-size: 16px;
        background-color: #fff;
        font-family: Arial-Regular, Arial;
        font-weight: 400;
        color: #2a358e;
        background-clip: text;
        img {
          width: 16px;
          height: 16px;
          margin-left: 22px;
        }
      }
      .content1-button:hover {
        background-color: #2a358e;
        color: #fff;
      }
    }
  }
  // .content-2 {
  //   height: 318px;
  //   padding-top: 60px;
  //   background: #f7f8fa;
  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  //   h1 {
  //     font-size: 40px;
  //     opacity: 0;
  //     font-family: Arial-Bold, Arial;
  //     font-weight: bold;
  //     color: #2a2e2e;
  //     margin-bottom: 40px;
  //     margin-top: 0;
  //   }
  //   .move7 {
  //     opacity: 0;
  //   }
  //   .why {
  //     display: flex;
  //     opacity: 0;
  //     align-items: center;
  //     cursor: pointer;
  //     margin-bottom: 34px;
  //     div {
  //       border-radius: 50%;
  //       width: 10px;
  //       height: 10px;
  //       margin-right: 6px;
  //       background: #2a358e;
  //     }

  //     font-size: 20px;
  //     font-family: Arial-Regular, Arial;
  //     font-weight: 400;
  //     color: #2a358e;
  //   }
  //   .img-list {
  //     margin: 40px auto;
  //     width: 1440px;
  //     display: flex;
  //     justify-content: space-between;
  //     .card {
  //       position: relative;
  //       width: 345px;
  //       height: 200px;
  //       border-radius: 10px 10px 10px 10px;
  //       .card-img {
  //         width: 345px;
  //         height: 200px;
  //         border-radius: 10px 10px 10px 10px;
  //       }
  //       .card-color {
  //         position: absolute;
  //         z-index: 1;
  //         top: 0;
  //         left: 0;
  //         border-radius: 10px 10px 10px 10px;
  //         height: 100%;
  //         width: 100%;
  //         background: rgba(0, 0, 0, 0.5);
  //       }
  //       .card-text {
  //         position: absolute;
  //         width: 80%;
  //         text-align: left;
  //         top: 50px;
  //         left: 30px;
  //         z-index: 2;
  //         font-family: Arial-Bold, Arial;
  //         color: #ffffff;
  //         h1 {
  //           margin-bottom: 25px;
  //           margin-top: 0;
  //           font-size: 28px;
  //           font-weight: bold;
  //           font-family: Arial-Bold, Arial;
  //           color: #ffffff;
  //           opacity: 1;
  //         }
  //         label {
  //           font-size: 16px;
  //           font-weight: 400;
  //           line-height: 24px;
  //         }
  //       }
  //     }
  //   }
  // }
  .content-3 {
    background: #f8f9fa;
    height: 616px;
    display: flex;
    color: #ffffff;
    .content3-left {
      padding: 100px 0 60px calc((100vw - 1440px) / 2);
      text-align: left;
      width: calc(45% - ((100vw - 1440px) / 2));
      .move8 {
        opacity: 0;
      }
      .content3-p {
        width: 580px;
        h3 {
          width: 100%;
          font-size: 40px;
          font-family: Microsoft YaHei UI-Bold, Microsoft YaHei UI;
          font-weight: bold;
          color: #2a2e2e;
          line-height: 40px;
          margin-bottom: 25px;
          margin-top: 30px;
        }
      }
      .content3-list {
        display: flex;
        width: 100%;
        margin-top: 40px;
        flex-direction: column;
        .move9 {
          opacity: 0;
          display: flex;
          width: 100%;
          margin-bottom: 24px;
        }
        .move10 {
          opacity: 0;
          display: flex;
          width: 100%;
          margin-bottom: 24px;
        }
        .move11 {
          opacity: 0;
          display: flex;
          width: 100%;
          margin-bottom: 24px;
        }
        .move12 {
          opacity: 0;
          display: flex;
          width: 100%;
          margin-bottom: 24px;
        }
        .card {
          display: flex;
          width: 80%;
          // .card-img {
          //   height: 50px;
          //   width: 50px;
          //   margin-right: 22px;
          // }
          .card-text {
            display: flex;
            flex-direction: column;
            .text-top {
              font-size: 18px;
              font-family: Arial-Bold, Arial;
              font-weight: bold;
              color: #2a2e2e;
              line-height: 30px;
            }
            .text-bottom {
              font-size: 16px;
              font-family: Arial-Regular, Arial;
              font-weight: 400;
              color: #646a73;
              line-height: 30px;
            }
          }
        }
      }
    }
    .content3-right {
      position: relative;
      width: 50%;
      height: 100%;
      .surname3 {
        width: 85%;
        height: calc(100% - 48px);
        position: absolute;
        z-index: 1;
        bottom: -32px;
        left: 5%;
        transform: scaleX(0);
        border-radius: 10px;
        background-color: rgba(241, 243, 246, 0.7);
      }
      .surname4 {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        transform: scaleX(0);
        border-radius: 10px;
        background-color: rgba(241, 243, 246, 1);
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .content-4 {
    padding: 120px 0 40px 0;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    width: calc(100% - 480px);
    align-items: center;
    .content4-svg {
      width: 52px;
      height: 52px;
      margin-bottom: 14px;
    }
    .move13 {
      opacity: 0;
    }
    h3 {
      width: 738px;
      font-size: 40px;
      font-family: Microsoft YaHei UI-Bold, Microsoft YaHei UI;
      font-weight: bold;
      color: #2a2e2e;
      opacity: 0;
      line-height: 60px;
      margin-bottom: 16px;
      margin-top: 0;
    }
    .content4-button {
      opacity: 0;
      cursor: pointer;
      padding: 9px 22px 9px 22px;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      align-items: center;
      border: 2px solid #2a358e;
      font-size: 16px;
      background-color: #fff;
      font-family: Arial-Regular, Arial;
      font-weight: Regular;
      color: #2a358e;
      background-clip: text;
      img {
        width: 16px;
        height: 16px;
        margin-left: 22px;
      }
    }
    .content4-button:hover {
      background-color: #2a358e;
      color: #fff;
    }
    .card-list {
      width: 1440px;
      margin: 80px 0;
      display: flex;
      justify-content: space-between;
      padding: 0 0 40px 0;
      .card {
        display: flex;
        width: 305px;
        height: 307px;
        flex-direction: column;
        padding: 50px 20px;
        align-items: center;
        background: #f7f8fa;
        color: #2a2e2e;
        border-radius: 12px 12px 12px 12px;
        h1 {
          font-size: 26px;
          font-weight: bold;
          line-height: 26px;
          margin: 34px 0 24px 0;
        }
        p {
          line-height: 24px;
          font-size: 16px;
        }
      }
      .card:hover {
        background: #111747;
        color: #ffffff;
      }
    }
  }
  .content-5 {
    height: 310px;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url("http://imarshi-web.oss-cn-shanghai.aliyuncs.com/image/help-you.png");
    .content5-help {
      height: 230px;
      width: 771px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 40px auto;
      background-color: rgba(0, 0, 0, 0.6);
      h1 {
        font-size: 40px;
        font-family: Arial-Bold, Arial;
        font-weight: bold;
        color: #ffffff;
        margin-top: 50px;
        margin-bottom: 46px;
      }
      .content5-button {
        cursor: pointer;
        padding: 9px 22px 9px 22px;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        align-items: center;
        border: 2px solid #fff;
        background-color: rgba(0, 0, 0, 0);
        font-size: 16px;
        font-family: Arial-Regular, Arial;
        font-weight: Regular;
        color: #fff;
        background-clip: text;
        img {
          width: 16px;
          height: 16px;
          margin-left: 22px;
        }
      }
      .content5-button:hover {
        background: #fff;
        color: #000;
      }
    }
  }
  .seced {
    display: flex;
    // opacity: 0;
    align-items: center;
    cursor: pointer;
    padding-bottom: 40px;
    border-bottom: 1px solid #dee0e3;
    div {
      border-radius: 50%;
      width: 10px;
      height: 10px;
      margin-right: 6px;
      background: #2a358e;
    }

    font-size: 16px;
    font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI-MONOSPACE;
    font-weight: 400;
    color: #2a358e;
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI-MONOSPACE;
    font-weight: 400;
    color: #2a358e;
    line-height: 30px;
    height: 22px;
    padding-bottom: 40px;
    margin-bottom: 20px;
    div {
      width: 10px;
      height: 10px;
      background: #2a358e;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
}
</style>